import React from 'react';
import PropTypes from 'prop-types';
import { Platform, Pressable } from 'react-native';
import styled from 'styled-components/native';
import images from '../assets/images';
import Icon from '../icon';
import Colors from '../colors';
import Text from '../text';
import useMobile from '../hooks/use-mobile';
import MainMenu from './main-menu';
import Header from './header';
import colorTheme from './color-theme';
const HeaderLogo = styled.Image`
  height: 17px;
  width: 87px;
`;
const NotificationActiveContainer = styled.View`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 9999;
`;
const CloseContainer = styled.View`
  height: 49px;
  align-items: flex-end;
  justify-content: center;
  padding-horizontal: 24px;
  background-color: ${Colors.white};
`;
const HeaderContainer = styled.View`
  padding-horizontal: 24px;
  background-color: ${Colors.white};
  padding-bottom: 8px;
`;
const NotificationContainer = styled.View`
  position: relative;
`;
const NotificationDot = styled.Pressable`
  background-color: ${Colors.error400};
  height: 18px;
  width: 18px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  border-width: 2px;
  border-color: ${Colors.white};
  position: absolute;
  top: -4px;
  right: -4px;
  z-index: 9999;
`;
export default function NavigationMenu(props) {
  const {
    mainMenuItems,
    fullName,
    theme,
    dropdownItems,
    dropdownHelpMenuItems,
    onBurgerClick,
    onLogoPress,
    breakPoint,
    renderNotifications,
    notificationActive,
    setNotificationActive,
    unreadNotificationsCount
  } = props;
  const mobile = useMobile(breakPoint);
  const logo = theme === 'default' ? images.AdvanceLogoWhite : images.AdvanceLogoBlue;

  if (mobile) {
    if (notificationActive) {
      return /*#__PURE__*/React.createElement(NotificationActiveContainer, null, /*#__PURE__*/React.createElement(CloseContainer, null, /*#__PURE__*/React.createElement(Icon.MaterialCommunityIcons, {
        name: "close",
        color: Colors.gray400,
        size: 24,
        onPress: () => setNotificationActive(false)
      })), /*#__PURE__*/React.createElement(HeaderContainer, null, /*#__PURE__*/React.createElement(Text.BodyBase, {
        weight: "medium",
        color: Colors.gray400
      }, "Notifications")), renderNotifications(breakPoint));
    }

    return /*#__PURE__*/React.createElement(Header, {
      theme: theme,
      renderLeft: () => /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
        name: "menu",
        size: 24,
        color: colorTheme[theme].iconColor,
        onPress: onBurgerClick
      }),
      renderCenter: () => /*#__PURE__*/React.createElement(Pressable, {
        onPress: onLogoPress
      }, Platform.select({
        web: /*#__PURE__*/React.createElement(HeaderLogo, {
          source: {
            uri: logo
          },
          resizeMode: "contain"
        }),
        default: /*#__PURE__*/React.createElement(HeaderLogo, {
          source: logo,
          resizeMode: "contain"
        })
      })),
      renderRight: () => /*#__PURE__*/React.createElement(NotificationContainer, null, /*#__PURE__*/React.createElement(Icon.MaterialCommunityIcons, {
        name: "bell",
        size: 24,
        color: colorTheme[theme].iconColor,
        onPress: () => setNotificationActive(true)
      }), !!unreadNotificationsCount && /*#__PURE__*/React.createElement(NotificationDot, {
        onPress: () => setNotificationActive(true)
      }, /*#__PURE__*/React.createElement(Text, {
        color: Colors.white,
        align: "center"
      }, unreadNotificationsCount)))
    });
  }

  return /*#__PURE__*/React.createElement(MainMenu, {
    logo: logo,
    onLogoPress: onLogoPress,
    theme: theme,
    mainMenuItems: mainMenuItems,
    dropdownItems: dropdownItems,
    dropdownHelpMenuItems: dropdownHelpMenuItems,
    fullName: fullName,
    renderNotifications: () => renderNotifications(breakPoint),
    notificationActive: notificationActive,
    setNotificationActive: setNotificationActive,
    unreadNotificationsCount: unreadNotificationsCount
  });
}
NavigationMenu.Header = Header;
NavigationMenu.defaultProps = {
  mainMenuItems: [],
  dropdownItems: [],
  dropdownHelpMenuItems: [],
  fullName: '',
  theme: 'default',
  onBurgerClick: () => null,
  onLogoPress: () => null,
  breakPoint: 875,
  renderNotifications: () => null,
  notificationActive: false,
  setNotificationActive: () => null,
  unreadNotificationsCount: 0
};
NavigationMenu.propTypes = {
  mainMenuItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    onPress: PropTypes.func,
    href: PropTypes.string,
    position: PropTypes.oneOf(['left', 'right'])
  })),
  dropdownItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    icon: PropTypes.string,
    subItems: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      icon: PropTypes.string,
      subItems: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        icon: PropTypes.string
      }))
    }))
  })),
  dropdownHelpMenuItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    onPress: PropTypes.func
  })),
  fullName: PropTypes.string,
  theme: PropTypes.oneOf(['default', 'light']),
  onBurgerClick: PropTypes.func,
  onLogoPress: PropTypes.func,
  breakPoint: PropTypes.number,
  renderNotifications: PropTypes.func,
  notificationActive: PropTypes.bool,
  setNotificationActive: PropTypes.func,
  unreadNotificationsCount: PropTypes.number
};
//# sourceMappingURL=index.js.map